import { DocumentSnapshot } from '../FirestoreTypes';
import { BaseDocument } from './BaseDocument';
import { ResourceSchema } from '../schemas/Resource';

export class ResourceDocument extends BaseDocument<ResourceSchema> {
    constructor(snapshot: DocumentSnapshot<ResourceSchema>) {
        super(snapshot, 'Resource');
    }
}
